import * as React from "react";
import { IconProps } from "common/assets/icons/types";

export const RadioCheckedIcon: React.FC<IconProps> = ({
  color = "#46947a",
  altText,
}) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      {altText && <title id="checkedPrimaryId">{altText}</title>}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <g transform="translate(6.25 6.25)" fill={color}>
          <circle fillRule="nonzero" opacity=".12" cx="9.75" cy="9.75" r="9" />
          <path d="M1.5 9.75a8.25 8.25 0 0 1 11.916-7.393.75.75 0 1 0 .668-1.343A9.713 9.713 0 0 0 9.75 0C4.365 0 0 4.365 0 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75c0-.366-.02-.727-.06-1.082a.75.75 0 1 0-1.49.164A8.25 8.25 0 1 1 1.5 9.75Zm17.78-6.47a.75.75 0 0 0-1.06-1.06l-8.47 8.47-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l9-9Z" />
        </g>
      </g>
    </svg>
  );
};
